export default "__VITE_ASSET__Q6EJyJKT__"